import './index.css';
import _extends from '@babel/runtime-corejs3/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.pcss.js';

var svgClassName = styles['wt-icon'];
var Size = {
  "xs": "xs",
  "s": "s",
  "m": "m",
  "l": "l"
};
var LoadingIcon = React.forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      size = _ref.size,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["theme", "size", "className"]);

  if (size === Size['xs']) {
    return React.createElement("svg", _extends({
      id: "svg6",
      viewBox: "0 0 16 16"
    }, props, {
      className: cn(svgClassName, styles[theme], styles[size], className),
      ref: ref
    }), React.createElement("style", null, "@keyframes wt-icon-rotate{to{transform:rotate(360deg)}}"), React.createElement("path", {
      d: "M8 1.5A6.507 6.507 0 0 0 1.5 8h1.114A5.386 5.386 0 1 1 8 13.386V14.5a6.5 6.5 0 1 0 0-13z",
      style: {
        animation: "wt-icon-rotate .7s linear infinite",
        transformOrigin: "center center"
      }
    }));
  }

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props, {
    className: cn(svgClassName, styles[theme], styles[size], className),
    ref: ref
  }), React.createElement("style", null, "@keyframes wt-icon-rotate{to{transform:rotate(360deg)}}"), React.createElement("path", {
    d: "M12 3.25A8.76 8.76 0 0 0 3.25 12h1.5A7.25 7.25 0 1 1 12 19.25v1.5a8.75 8.75 0 1 0 0-17.5z",
    style: {
      animation: "wt-icon-rotate .7s linear infinite",
      transformOrigin: "center center"
    }
  }));
});
LoadingIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["xs", "s", "m", "l"])
};
LoadingIcon.defaultProps = {
  size: "m"
};
var LoadingIcon$1 = LoadingIcon;

export { Size, LoadingIcon$1 as default };
